(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('sharedChartService', ['localStorageService', function (localStorageService) {

            function initialiseWatch($scope, propertyName, apiSpace, controllerName){
                var storageName = apiSpace + "_" + controllerName + "_" + propertyName;
                var property = localStorageService.getObject(storageName);
                $scope.$watch(propertyName, function(){
                    var newProperty = _.get($scope, propertyName);
                    if(newProperty && newProperty != property){
                        localStorageService.setObject(storageName, newProperty);
                    }
                })

                return property;
            }

            var fac = {
                initialiseWatch: initialiseWatch
            };
            
            return fac;

    }]);
})(window.angular);